<template>
  <textarea
      :class="[
        styles.textarea,
        { 'border-red-500 hover:border-red-500 focus:border-red-600 text-red-600': hasErrors }
        ]"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @keyup="$root !== undefined && $root.hasOwnProperty('stopArrows') ? $root.stopArrows($event) : ''"
  ></textarea>
</template>

<script>
export default {
  name: 'BaseTextArea',
  props: {
    hasErrors: {
      type: Boolean,
      default: false
    },

    value: {
      type: [String, Number, Boolean],
      required: true
    }
  },

  emits: ['input'],
  data () {
    return {
      styles: window.myStyles
    }
  }
}
</script>

<style scoped>

</style>
